// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UserGroupsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.UserGroupFilter>;
}>;


export type UserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, name: string, internalUser?: { __typename?: 'InternalUser', id: string, avatar: string } | null | undefined }> }> };

export type UserGroupsMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserGroupsMetadataQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string } }> };

export type SaveUserGroupMutationVariables = Types.Exact<{
  input: Types.SaveUserGroupInput;
}>;


export type SaveUserGroupMutation = { __typename?: 'Mutation', saveUserGroup: { __typename?: 'SaveUserGroupResult', userGroup: { __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, name: string, internalUser?: { __typename?: 'InternalUser', id: string, avatar: string } | null | undefined }> } } };

export type RemoveUserGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveUserGroupMutation = { __typename?: 'Mutation', removeUserGroup: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type UserGroupFragment = { __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, name: string, internalUser?: { __typename?: 'InternalUser', id: string, avatar: string } | null | undefined }> };

export const UserGroupFragmentDoc = gql`
    fragment UserGroup on UserGroup {
  id
  name
  users {
    id
    name
    internalUser {
      id
      avatar
    }
  }
}
    `;
export const UserGroupsDocument = gql`
    query UserGroups($filter: UserGroupFilter) {
  userGroups(filter: $filter) {
    ...UserGroup
  }
}
    ${UserGroupFragmentDoc}`;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export function useUserGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserGroupsSuspenseQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const UserGroupsMetadataDocument = gql`
    query UserGroupsMetadata {
  internalUsers {
    id
    name
    avatar
    user {
      id
    }
  }
}
    `;

/**
 * __useUserGroupsMetadataQuery__
 *
 * To run a query within a React component, call `useUserGroupsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGroupsMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>(UserGroupsMetadataDocument, options);
      }
export function useUserGroupsMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>(UserGroupsMetadataDocument, options);
        }
export function useUserGroupsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>(UserGroupsMetadataDocument, options);
        }
export type UserGroupsMetadataQueryHookResult = ReturnType<typeof useUserGroupsMetadataQuery>;
export type UserGroupsMetadataLazyQueryHookResult = ReturnType<typeof useUserGroupsMetadataLazyQuery>;
export type UserGroupsMetadataSuspenseQueryHookResult = ReturnType<typeof useUserGroupsMetadataSuspenseQuery>;
export type UserGroupsMetadataQueryResult = Apollo.QueryResult<UserGroupsMetadataQuery, UserGroupsMetadataQueryVariables>;
export const SaveUserGroupDocument = gql`
    mutation SaveUserGroup($input: SaveUserGroupInput!) {
  saveUserGroup(input: $input) {
    userGroup {
      ...UserGroup
    }
  }
}
    ${UserGroupFragmentDoc}`;
export type SaveUserGroupMutationFn = Apollo.MutationFunction<SaveUserGroupMutation, SaveUserGroupMutationVariables>;

/**
 * __useSaveUserGroupMutation__
 *
 * To run a mutation, you first call `useSaveUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserGroupMutation, { data, loading, error }] = useSaveUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUserGroupMutation, SaveUserGroupMutationVariables>(SaveUserGroupDocument, options);
      }
export type SaveUserGroupMutationHookResult = ReturnType<typeof useSaveUserGroupMutation>;
export type SaveUserGroupMutationResult = Apollo.MutationResult<SaveUserGroupMutation>;
export type SaveUserGroupMutationOptions = Apollo.BaseMutationOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>;
export const RemoveUserGroupDocument = gql`
    mutation RemoveUserGroup($id: ID!) {
  removeUserGroup(id: $id) {
    emptyResult
  }
}
    `;
export type RemoveUserGroupMutationFn = Apollo.MutationFunction<RemoveUserGroupMutation, RemoveUserGroupMutationVariables>;

/**
 * __useRemoveUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserGroupMutation, { data, loading, error }] = useRemoveUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserGroupMutation, RemoveUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserGroupMutation, RemoveUserGroupMutationVariables>(RemoveUserGroupDocument, options);
      }
export type RemoveUserGroupMutationHookResult = ReturnType<typeof useRemoveUserGroupMutation>;
export type RemoveUserGroupMutationResult = Apollo.MutationResult<RemoveUserGroupMutation>;
export type RemoveUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserGroupMutation, RemoveUserGroupMutationVariables>;